import { Box, Button } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React from 'react';

function RadixGhostButton({ onClick, color, needsMarginTop, disabled, children }) {
  return (
    <Box
      height='32px'
      mt={needsMarginTop ? '1' : '0'}
      m='0'
      px='3'
      py='0'
      asChild
    >
      <Button
        variant='ghost'
        color={color}
        size='2'
        radius='full'
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </Button>
    </Box>
  );
}

RadixGhostButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  color: PropTypes.string,
  needsMarginTop: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default RadixGhostButton;
